import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const CheckUserSupplierMembershipDocument = gql`
  query CheckUserSupplierMembership($supplierUUID: uuid!, $userUUID: uuid!) {
    businesses_by_pk(uuid: $supplierUUID) {
      uuid
      businesses_employees(where: { employee_uuid: { _eq: $userUUID } }) {
        uuid
        employee_uuid
        business_uuid
      }
    }
  }
`;
export function useCheckUserSupplierMembershipQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.CheckUserSupplierMembershipQuery,
    Types.CheckUserSupplierMembershipQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.CheckUserSupplierMembershipQuery,
    Types.CheckUserSupplierMembershipQueryVariables
  >(CheckUserSupplierMembershipDocument, options);
}
export function useCheckUserSupplierMembershipLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.CheckUserSupplierMembershipQuery,
    Types.CheckUserSupplierMembershipQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.CheckUserSupplierMembershipQuery,
    Types.CheckUserSupplierMembershipQueryVariables
  >(CheckUserSupplierMembershipDocument, options);
}
export type CheckUserSupplierMembershipQueryHookResult = ReturnType<
  typeof useCheckUserSupplierMembershipQuery
>;
export type CheckUserSupplierMembershipLazyQueryHookResult = ReturnType<
  typeof useCheckUserSupplierMembershipLazyQuery
>;
export type CheckUserSupplierMembershipQueryResult = Apollo.QueryResult<
  Types.CheckUserSupplierMembershipQuery,
  Types.CheckUserSupplierMembershipQueryVariables
>;

/**
 * Wrapped version of useGeneratedCheckUserSupplierMembershipQuery using Pepper's useWrappedQuery
 */
export function useGeneratedCheckUserSupplierMembershipQuery(
  options?: Apollo.QueryHookOptions<
    Types.CheckUserSupplierMembershipQuery,
    Types.CheckUserSupplierMembershipQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.CheckUserSupplierMembershipQuery,
    Types.CheckUserSupplierMembershipQueryVariables
  >(CheckUserSupplierMembershipDocument, options);
}

/**
 * Wrapped version of useGeneratedCheckUserSupplierMembershipLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedCheckUserSupplierMembershipLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.CheckUserSupplierMembershipQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.CheckUserSupplierMembershipQuery,
    Types.CheckUserSupplierMembershipQueryVariables
  >(CheckUserSupplierMembershipDocument, lazyOptions);
}
